/** @format */

import { createAsyncThunk } from "@reduxjs/toolkit";
import { alertMsg } from "../utilities/helper";
import { deleteReq, getReq, postReq } from "./APIMethods";

export const getDashboard = createAsyncThunk(
  "dashboard/getData",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq(obj.url);

      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);

export const getAllOrders = createAsyncThunk(
  "orders/allOrders",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq("/orders");

      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);

export const getOrderDetailes = createAsyncThunk(
  "orders/orderDetailes",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq("/orders/" + obj.id);

      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);

export const updateOrder = createAsyncThunk(
  "orders/updateOrder",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await postReq(
        "/orders/update-status/" + obj.id,
        obj.params
      );
      alertMsg("تم التعديل بنجاح  ", true);
      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
export const deleteOrder = createAsyncThunk(
  "orders/deleteOrder",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await deleteReq("/orders/" + obj.id);
      alertMsg("تم الحذف بنجاح  ", true);
      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
